import { unescape } from "utils/helpers"
import { shape, bool, string, func } from "prop-types"
import { Box, Button, StackView } from "@planningcenter/tapestry-react"
import { colors } from "components/shared/admin_colors"

const ExistingContact = ({ responsiblePerson, isAdmin, isClearable, onClear }) => {
  const personName = unescape(responsiblePerson.name)

  return (
    <div>
      <StackView axis="horizontal" alignment="center" spacing={2}>
        <img
          src={`${responsiblePerson?.avatar_url || responsiblePerson?.avatarUrl}?g=96x96%23`}
          alt={personName}
          className="w-6 h-6 circle"
        />
        <Box>
          <StackView axis="horizontal" alignment="center" spacing={1}>
            <h1 className="mb-0 font-size-2">
              {responsiblePerson.person_url && isAdmin ? (
                <a href={responsiblePerson.person_url}>{personName}</a>
              ) : (
                personName
              )}
            </h1>

            {isClearable && (
              <Button
                onClick={onClear}
                size="xs"
                variant="naked"
                icon={{
                  name: "general.x",
                  size: "md",
                  color: colors.error
                }}
                title="Remove"
              />
            )}
          </StackView>
          <div className="font-size-4">{responsiblePerson.email}</div>
        </Box>
      </StackView>
    </div>
  )
}

ExistingContact.propTypes = {
  responsiblePerson: shape({
    person_url: string,
    avatar_url: string,
    avatarUrl: string,
    email: string
  }),
  isAdmin: bool,
  isClearable: bool,
  onClear: func
}

ExistingContact.defaultProps = {
  isClearable: false,
  onClear: () => {}
}

export default ExistingContact
